import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { TipoLojaProps } from 'components/autocompletes/TipoLojaAutoComplete';
import { useRequestListagem } from 'hooks/useRequestListagem';

const PROPRIA = 1;
const FRANQUIA = 2;
const GRUPO_FIT = 8;

export function useQueryTipoLojaDefault() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();

    return useQuery<TipoLojaProps[]>(
        ['queryTipoLojaDefault'],
        () =>
            requestListagem({
                url: '/gestao/tipoloja',
                sort: [{ property: 'dsTipoLoja', direction: 'ASC' }],
                filter: [{ property: 'idTipoLoja', operator: 'in', value: [PROPRIA, FRANQUIA, GRUPO_FIT] }],
            }).then((res) => res?.data?.data),
        {
            initialData: [],
            enabled: !id,
        },
    );
}
